import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/feature/Reveal';

const ITEMS = [
  {
    id: 'babysit',
    title: 'You do not babysit it',
    text: 'Once it is attached, GoldWarden opens, protects and closes its own trades. You can switch away from the chart — you just need MetaTrader 5 to stay open.',
  },
  {
    id: 'disconnect',
    title: 'If it disconnects',
    text: 'Stops and targets are already lodged with your broker, so open positions stay protected even if the terminal or your internet drops. The EA resumes managing them once MT5 is back.',
  },
  {
    id: 'custody',
    title: 'Your account stays yours',
    text: 'The EA runs inside your own broker account. It never touches withdrawals, and there is no copy-trading or third-party signal feed involved.',
  },
];

export default function AfterLaunch() {
  return (
    <section id="after-launch" className="py-14 md:py-20 bg-background-100 scroll-mt-32 md:scroll-mt-36">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-shell mx-auto">
          <Reveal>
            <SectionHeading
              eyebrow="In practice"
              title="What running it actually looks like"
              subtitle="Here is what it asks of you while it trades — and what stays firmly in your hands."
            />
          </Reveal>

          <div className="mt-10 md:mt-12 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {ITEMS.map((item, index) => (
              <Reveal key={item.id} delay={index * 60}>
                <div className="group h-full rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 hover:border-accent-300 transition-colors duration-200">
                  <div className="h-full border-l-2 border-accent-400 pl-4 md:pl-5 transition-colors duration-200 group-hover:border-accent-500">
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">{item.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}